import { inject, injectable } from "inversify";
import ApiRepo from "./api.repo";
import { ApiPage } from "@/core/models/page.model";
import { UserDetail } from "../models/auth/auth.model";

@injectable()
export class UserRepo {
    @inject(ApiRepo)
    private apiRepo!: ApiRepo;

    async getFromFactory(): Promise<UserDetail[]> {
        const response = await this.apiRepo.get<ApiPage<UserDetail>>("/api/AppUser/all-by-water-factory");
        if (response?.code === "00") {
            return response.result.data;
        }
        return [];
    }
}